import { type SocietyDashboardModuleView } from "shared/mappers/database/dashboard/society-dashboard-module";

export const useDashboardColumns = ({
  dashboards,
}: {
  dashboards?: SocietyDashboardModuleView[];
}) => {
  if (!dashboards?.length) {
    return 12;
  }

  const maxColsPerRow = dashboards.reduce<Record<number, number>>((acc, dm) => {
    const row = dm.positionRow ?? 1;
    const startCol = dm.positionColumn ?? 1;
    const span = dm.colSpan ?? 1;
    const endCol = startCol + span - 1;

    acc[row] = Math.max(acc[row] ?? 0, endCol);
    return acc;
  }, {});

  const maxCols = Math.max(...Object.values(maxColsPerRow));
  return Math.min(Math.max(maxCols, 1), 12);
};
